<main>
  <!-- Hero Section -->
  <section id="hero" class="w-100"
    style="margin-top: 66px; background: linear-gradient(45deg, #1a2042, #173580); color: #fff">
    <div class="d-flex h-100 align-items-center justify-content-between container pt-5 pb-3 pb-lg-5 pt-lg-5">
      <!-- Left -->
      <div class="">
        <h1 class="fw-medium">Looking for a job in software industry?</h1>
        <p class="fw-semibold">Need support to convert opportunity to job offer ?</p>

        <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3"
          (click)="trackRegistrationClick();navigateAndScroll('/home','register')">
          Sign up for free
        </button>
      </div>

      <!-- <section id="achievements" class="mt-5 d-none d-lg-flex flex-column">
        <h1 class="text-center d-inline-block fw-semibold">Our Achievements</h1>
        <p class="text-center">Trusted by thousands of learners worldwide 🚀</p>

        <div class="d-flex justify-content-between">
          <div class="">
            <h3 class="display-5 fw-bold">{{ students }}</h3>
            <p>Active Students</p>
          </div>
          <div class="">
            <h3 class="display-5 fw-bold">{{ mentors }}</h3>
            <p>Expert Mentors</p>
          </div>
        </div>
      </section> -->
    </div>
  </section>


  <!-- Info + Registration Form Section -->
  <section id="courses" class="py-5 bg-light">
    <div class="container">
      <div class="row align-items-center">
        <!-- Left -->
        <div class="col-lg-6 pe-lg-5">
          <h3 class="mb-2 pb-2 fw-bold d-inline-block">UPCOMING WORKSHOP</h3>
          <p class="mb-4 lead fw-normal" style="color: gray">
            Ready to break into the software industry or level up your current position? Join our
            intensive workshop where industry experts will guide you through everything you
            need to land your dream tech job.
          </p>
          <div>
            <div class="workshop-details shadow">
              <h4 class="fw-semibold mb-3 text-dark"><i class="fas fa-calendar-alt me-2 text-primary"></i>Workshop
                Details:</h4>
              @if(workshop){
              <div class="row">
                <div class="col-md-6 mb-3">
                  <strong><i class="fas fa-calendar me-2"></i>Date:</strong><br>
                  <span class="text-muted">{{ formatDateRange(workshop.date) }}</span>
                  <!-- January 5-7, 2026 -->
                </div>
                <div class="col-md-6 mb-3">
                  <strong><i class="fas fa-clock me-2"></i>Time:</strong><br>
                  <span class="text-muted">{{ formatTimeRange(workshop?.timeFrom, workshop?.timeTo) }}</span>
                </div>
                <div class="col-md-6 mb-3 text-truncate link">
                  <strong><i class="fas fa-laptop me-2"></i>Format:</strong><br>
                  @if (workshop?.online) {
                  <span class="badge bg-success me-1" *ngIf="workshop?.online">Online</span>
                  <br>
                  <!-- <a [href]="workshop?.workshopLink" class="link-unstyled text-truncate link"
                    target="_blank">{{workshop?.workshopLink}}</a> -->
                  }
                  @if(workshop?.offline){
                  <span class="badge bg-info">Offline</span>
                  }
                </div>
                <div class="col-md-6 mb-3">
                  <strong><i class="fas fa-map-marker-alt me-2"></i>Offline Location:</strong><br>
                  <!-- <span class="text-muted">Tech Hub, Cyber City<br>Gurugram, Haryana</span> -->
                  <span class="text-muted">{{workshop?.location}}</span>
                </div>
              </div>
              }
            </div>

            <div class="price-tag pe-auto shadow" style="background:  linear-gradient(45deg, #1A2042, #173580); ">
              <i class="fas fa-tag me-2"></i> ₹{{workshop?.price}} <span class="text-decoration-line-through ms-1"
                style="color: gray;">₹{{workshop?.oldPrice}}</span>
            </div>

            <p class="text-danger">Only {{workshop?.seats}} seats remaining!</p>
            <div>
              <h3>What to expect:</h3>
              <!-- <ul>
                <li>Tips to crack technical & HR interview in IT company</li>
                <li>Experience sharing by industry experts</li>
                <li>Certification after successful completion of workshop</li>
                <li>Post workshop support</li>
              </ul> -->

              {{workshop?.description}}
            </div>
          </div>
        </div>

        <!-- Right: Form -->
        <div class="col-lg-6">
          <div class="card shadow p-4 p-lg-5 m-3 rounded-3" style="border-radius: 10px;
            border-top: 5px solid #00346b;">
            <h2 class="text-center mb-4">Register Now</h2>
            <form [formGroup]="registerForm" (ngSubmit)="submit()" id="register">
              <div class="mb-3">
                <label for="name" class="form-label fw-semibold mb-2">Full Name</label>

                <div class="mb-4">
                  <input type="text" class="form-control p-3 rounded-2" id="name" formControlName="name" />
                  <small class="text-danger"
                    *ngIf="registerForm.get('name')?.touched && registerForm.get('name')?.invalid">Name is
                    required.</small>
                </div>
              </div>
              <div class="mb-3">
                <label for="email" class="form-label fw-semibold mb-2">Email Address</label>
                <div class="mb-4">
                  <input type="email" class="form-control p-3 rounded-2" id="email" formControlName="email" />
                  <small class="text-danger"
                    *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.hasError('required')">Email
                    is
                    required</small>
                  <small class="text-danger"
                    *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.hasError('email') && registerForm.get('email')?.invalid">Invalid
                    email format.</small>
                </div>
              </div>
              <div class="mb-3">
                <label for="phone" class="form-label fw-semibold mb-2">Phone Number</label>
                <div class="mb-4">
                  <input type="tel" class="form-control p-3 rounded-2" id="phone" formControlName="phoneNumber" />
                  <small class="text-danger"
                    *ngIf="registerForm.get('phoneNumber')?.touched && registerForm.get('phoneNumber')?.hasError('required')">
                    Phone number is required.
                  </small>
                  <small class="text-danger"
                    *ngIf="registerForm.get('phoneNumber')?.touched && registerForm.get('phoneNumber')?.hasError('minlength')">
                    Phone number must be 10 digits.
                  </small>
                  <small class="text-danger"
                    *ngIf="registerForm.get('phoneNumber')?.touched && registerForm.get('phoneNumber')?.hasError('maxlength')">
                    Phone number must be 10 digits.
                  </small>
                </div>
              </div>
              <div class="mb-3">
                <label for="college" class="form-label fw-semibold mb-2">College Name</label>
                <div class="mb-4">
                  <input type="text" class="form-control p-3 rounded-2" id="college" formControlName="collegeName" />
                  <small class="text-danger"
                    *ngIf="registerForm.get('collegeName')?.touched && registerForm.get('collegeName')?.invalid">
                    College name is required.
                  </small>
                  <small class="text-danger"
                    *ngIf="registerForm.get('collegeName')?.touched && registerForm.get('collegeName')?.hasError('maxlength')">
                    College name length should not exceed 50 characters.
                  </small>
                </div>
              </div>
              <div class="mb-3">
                <label for="universite" class="form-label fw-semibold mb-2">University Name</label>
                <div class="mb-4">
                  <input type="text" class="form-control p-3 rounded-2" id="universite"
                    formControlName="universityName" />
                  <small class="text-danger"
                    *ngIf="registerForm.get('universityName')?.touched && registerForm.get('universityName')?.invalid">
                    University name is required.
                  </small>
                  <small class="text-danger"
                    *ngIf="registerForm.get('universityName')?.touched && registerForm.get('universityName')?.hasError('maxlength')">
                    University name length should not exceed 50 characters.
                  </small>
                </div>
              </div>
              <div class="mb-3">
                <label for="branch" class="form-label fw-semibold mb-2"> Degree and Branch</label>
                <div class="mb-4">
                  <input type="text" class="form-control p-3 rounded-2" id="branch" formControlName="degreeandBranch" />
                  <small class="text-danger"
                    *ngIf="registerForm.get('degreeandBranch')?.touched && registerForm.get('degreeandBranch')?.invalid">
                    Degree and branch name is required.
                  </small>
                  <small class="text-danger"
                    *ngIf="registerForm.get('degreeandBranch')?.touched && registerForm.get('degreeandBranch')?.hasError('maxlength')">
                    Degree and branch name length should not exceed 50 characters.
                  </small>
                </div>
              </div>
              <div class="mb-3">
                <label for="yearOfPassing" class="form-label fw-semibold mb-2">Year of Passing</label>
                <div class="mb-4">
                  <p-datepicker id="yearOfPassing" [minDate]="minDate" [view]="'year'" [dateFormat]="'yy'"
                    [readOnlyInput]="true" [pClass]="['p-3','rounded-2']"
                    inputClass="p-3 rounded-2 w-full border-0 shadow-none" formControlName="passingYear"></p-datepicker>
                  <div>
                    <small class="text-danger"
                      *ngIf="registerForm.get('passingYear')?.touched && registerForm.get('passingYear')?.invalid">
                      Year of passing is required.
                    </small>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn-primary w-100 fw-semibold px-4 py-3 mt-3 rounded-2"
                style=" background: linear-gradient(45deg, #1a2042, #173580); color: #fff;">
                Register
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section -->
  <section id="why-us" class="py-5 mb-0 text-center" style="background: rgb(238, 238, 250); color: black">
    <div class="container">
      <h2 class="text-center pb-3 d-inline-block">Why Us</h2>
      <!-- <p class="text-center mb-5 fw-normal lead" style="color: gray">
        Our platform provides the tools, knowledge, and support to help you succeed.
      </p>

      <div class="row mt-4 g-4">
        <div class="col-lg-4 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="Purpose Icon" />
            </div>
            <h3>Purpose</h3>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dicta optio sed beatae ipsam
              fugiat repellendus nemo repellat, sint, quis excepturi quae dolorum. Sit earum, libero
              voluptatum pariatur ipsum consequatur sed nobis vel perspiciatis omnis cum dolorem
              facere eligendi, maxime numquam temporibus hic ipsa quidem. Sunt amet aliquid ullam
              nesciunt perspiciatis!.
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="Future Icon" />
            </div>
            <h3>Future Outlook</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos eum veritatis
              aut. Dignissimos dicta ad in? Itaque unde, velit distinctio quis deleniti doloremque
              adipisci quos voluptas vel consequuntur iusto magni enim vitae voluptates obcaecati
              laborum quam omnis perspiciatis nesciunt cum. Atque exercitationem repudiandae
              possimus aliquam dolores, quis suscipit hic delectus..
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-md-6">
          <div class="feature-card">
            <div class="feature-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="Values Icon" />
            </div>
            <h3>Core Principles</h3>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa illo fugit, pariatur
              laudantium harum suscipit veniam ratione ad nam nesciunt est qui adipisci temporibus
              officia! Quas iusto praesentium magni officiis dolorem sint, voluptas itaque
              temporibus aspernatur fuga ratione deserunt id iste soluta modi perferendis
              dignissimos provident a nam alias quibusdam..
            </p>
          </div>
        </div>
      </div> -->
      <div class="video-container">
        <video autoplay muted loop playsinline controls>
          <source src="Why-Us-3.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </section>

  <!-- About Section -->
  <section id="about" class="p-5" style="background: #eeedde; color: black">
    <div class="d-flex flex-column flex-lg-row-reverse aboutSection">
      <div class="flex-grow-1">
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDyxxzO-EN4RklWgjEZ-mb7xGBDD_fmYViBg&s"
          alt="Team Picture" class="rounded-3 img-fluid shadow-lg border border-light" />
      </div>
      <div class="pe-lg-5 mb-4 mb-lg-0 flex-grow-1">
        <h2 class="mb-4 fw-bold">About Our Team</h2>
        <p class="lead mb-4 fw-normal" style="color: gray">
          A group of software professions with 15+ years of industry experience working on a mission
          to train and mentor fresh graduates/under graduates to land on a desired and deserved job.
          .
        </p>
        <button class="btn btn-dark px-4 py-2 rounded-2 shadow-sm" (click)="navigatetoPath('about')">
          Connect with Us
        </button>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section id="cta" class="d-flex flex-column align-items-center py-5 px-4"
    style="background: linear-gradient(45deg, #0e0e0e, #111318); color: #fff">
    <h2 class="mb-4 pb-3 d-inline-block">Join group of passionate professionals to learn and grow.</h2>
    <p class="mb-4">Join thousands of students who are learning and earning with us.</p>
    <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3"
      (click)="trackRegistrationClick();navigateAndScroll('/home', 'register')">
      Register Now
    </button>
  </section>
</main>

<div #popup class="popdown card position-fixed bottom-0  w-100  bg-light h-full  position-relative">
  <div class="p-5 position-relative">
    <div class="d-flex text-end">
      <span class="fs-2 me-1 ms-auto" style="cursor: pointer;" (click)="hidePopup()">X</span>
    </div>
    <!-- <h1 class="position-absolute end-0" (click)="hidePopup()" style="cursor: pointer;">X</h1> -->
    <div class="text-center">
      <img src="https://via.placeholder.com/150x150?text=Tech+Workshop" alt="Software Career Workshop">
      <h2>Thank You!</h2>
      <p>for enrolling in our <strong>Launch Your Software Career Workshop</strong></p>
      <h4>Details</h4>
      <p><strong>Date:</strong> January 5, 2026</p>
      <p><strong>Time:</strong> 10:00 AM - 2:00 PM IST</p>
      <p><strong>Location:</strong> Online (Zoom link will be shared)</p>
      <p><strong>What to Expect:</strong> Expert-led sessions, coding simulations, resume-building tools, and live Q&A.
      </p>
      <p>Check your email for confirmation and further instructions.</p>
      <!-- <button class="btn btn-primary mt-3">Add to Calendar</button> -->
    </div>
  </div>
</div>